
import { FirestoreError } from "firebase/firestore";
import { toast } from "sonner";

export const useFirestoreError = () => {
  const handleFirestoreError = (error: FirestoreError | any) => {
    console.error("Firestore error:", error);

    if (error.code === "failed-precondition" && error.message.includes("index")) {
      // Extract the console URL from the error message
      const urlMatch = error.message.match(/https:\/\/console\.firebase\.google\.com[^\s"]*/);
      const indexUrl = urlMatch ? urlMatch[0] : null;

      toast.error(
        <div className="space-y-2">
          <p>Missing required index.</p>
          {indexUrl && (
            <a
              href={indexUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline block text-sm"
            >
              Click here to create the index
            </a>
          )}
        </div>
      );
    } else {
      toast.error(`Error: ${error.message}`);
    }
  };

  return { handleFirestoreError };
};
